// @vendors
import React, { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

// @assets
import { StatsStyles } from '../../../assets/css/statsBoxes-style';

// @components
import {
  AssignmentTurnedInOutlinedIcon,
  Grid,
  PersonAddAlt1OutlinedIcon,
  PersonOutlineOutlinedIcon,
  PersonRemoveOutlinedIcon
} from '../../../components/shared/MaterialUI';
import MobiledataOffOutlinedIcon from '@mui/icons-material/MobiledataOffOutlined';

// @constants
import { ROUTENAME } from '../../../navigation/RouteName';
import StatsBoxCard from '../../../components/atoms/StatsBoxCard';

export const StatsBoxes = ({stats}) => {
  const styles = useMemo(() => StatsStyles(), []);
  const history = useHistory();
  const location = useLocation();

  const activateFocusAdmin = () => {
    const input = document.getElementById('searchCompany')
    if(location?.pathname === ROUTENAME.dashboard)return input?.focus()
    else{
      history.push(ROUTENAME.dashboard)
      input?.focus()
    }
  }

  const activateFocusEmployee = () => {
    const input = document.getElementById('searchByEmployee')
    if(location?.pathname === ROUTENAME.searchEmployees)return input?.focus()
    else{
      history.push(ROUTENAME.searchEmployees)
      input?.focus()
    }
  }

  const participationRate = stats?.employees 
    ? `${((stats?.questionnaireCompleted / stats?.employees) * 100).toFixed(0)}%`
    : '0%';

  return (
    <>
      <Grid
        component={'section'}
        sx={{
          ...styles.container,
          margin: '40px 0 20px 0'
        }}
      >
        <StatsBoxCard
          title='Number of employers'
          iconStats={<PersonOutlineOutlinedIcon sx={styles.icon}/>}
          value={stats?.employers}
          hasButton={true}
          handleClick={() => activateFocusAdmin()}
        />

        <StatsBoxCard
          title='Number of employees'
          iconStats={<PersonAddAlt1OutlinedIcon sx={styles.icon}/>}
          value={stats?.employees}
          hasButton={true}
          handleClick={() => activateFocusEmployee()}
        />
      </Grid>

      <Grid
        component={'section'}
        sx={{
          ...styles.container,
          margin: '0 0 20px 0',
        }}
      >
        <StatsBoxCard
          title='Completed questionnaires'
          iconStats={<AssignmentTurnedInOutlinedIcon sx={styles.icon}/>}
          value={stats?.questionnaireCompleted}
          hasButton={false}
        />

        <StatsBoxCard
          title='Abandoned questionnaires'
          iconStats={<PersonRemoveOutlinedIcon sx={styles.icon}/>}
          value={stats?.questionnaireAbandoned}
          hasButton={false}
        />

        <StatsBoxCard
          title='Participation rate'
          iconStats={<MobiledataOffOutlinedIcon sx={styles.icon}/>}
          value={participationRate}
          hasButton={false}
          hasFooterText={'Based on completed  vs sent questionnaires'}
        />
      </Grid>
    </>
  );
};
